export default "__VITE_ASSET__a7cb4fb4__"